/**
 * Libellés harmonisés — espace Personnel d'administration.
 */

export const AP_COPY = {
  TAGLINE: 'Plateforme de santé au travail',

  LAYOUT: {
    NAVBAR_BRAND: 'Personnel d\'administration',
    TOPBAR_TAGLINE: 'Plateforme de santé au travail — adhérents, sociétés, tarification et facturation SMIE',
    SIDE_MENU_SECTION: 'Personnel d\'administration'
  },

  ROLE_LABEL_ADMIN_PERSONNEL: 'Personnel d\'administration',
  ROLE_LABEL_ADMIN: 'Administrateur',

  DASHBOARD: {
    BADGE: 'Personnel d\'administration',
    TITLE: 'Tableau de bord',
    REFRESH: 'Actualiser',
    WELCOME_SUB:
      'Vue d’ensemble : sociétés partenaires, adhérents et derniers mouvements au même endroit.',
    SECTION_QUICK: 'Actions rapides',
    STAT_COMPANIES: 'Sociétés',
    STAT_COMPANIES_SUB: (active, total) => `${active}/${total} actives`,
    STAT_MEMBERS: 'Adhérents',
    STAT_MEMBERS_SUB: (active, total) => `${active}/${total} actifs`,
    STAT_AGENTS: 'Agents',
    STAT_AGENTS_SUB: 'Employés actifs',
    STAT_DEPENDANTS: 'Ayants-droit',
    STAT_DEPENDANTS_SUB: (conjoints, enfants) =>
      `${conjoints} conjoint${conjoints === 1 ? '' : 's'}, ${enfants} enfant${enfants === 1 ? '' : 's'}`,
    QUICK_NEW_COMPANY_TITLE: 'Nouvelle société',
    QUICK_NEW_COMPANY_DESC: 'Créer ou mettre à jour une société partenaire',
    QUICK_NEW_MEMBER_TITLE: 'Nouvel adhérent',
    QUICK_NEW_MEMBER_DESC: 'Ajout manuel hors import DNS',
    QUICK_PRICING_TITLE: 'Tarification',
    QUICK_PRICING_DESC: 'Prix des consultations, examens et prises en charge',
    QUICK_INVOICES_TITLE: 'Facturation',
    QUICK_INVOICES_DESC: 'Soins et traitement · prises en charge',
    QUICK_ACTIVITIES_TITLE: 'Journal d’activités',
    QUICK_ACTIVITIES_DESC: 'Historique des créations, modifications et imports',
    QUICK_NOTIFICATIONS_TITLE: 'Notifications',
    QUICK_NOTIFICATIONS_DESC: 'Alertes sociétés, adhérents et suivi administratif'
  },

  COMPANIES: {
    PAGE_TITLE: 'Sociétés partenaires',
    PAGE_SUBTITLE:
      'Référentiel des sociétés adhérentes : affiliations SMIE (données référentiel), statuts et coordonnées.',
    AFFILIATION_ALL: 'Toutes affiliations',
    SEARCH_PLACEHOLDER: 'Code, nom, affiliation, e-mail ou téléphone…',
    BTN_CREATE: 'Nouvelle société',
    STATUS_ALL: 'Tous les statuts',
    STATUS_ACTIVE: 'Actives',
    STATUS_INACTIVE: 'Inactives'
  },

  MEMBERS: {
    PAGE_TITLE: 'Adhérents et ayants-droit',
    PAGE_SUBTITLE:
      'Parcourir ou filtrer la base par société · hiérarchie agent / famille · import en masse depuis l’onglet DNS.',
    TAB_LIST: 'Liste',
    TAB_ARCHIVES: 'Archives',
    TAB_IMPORT: 'Import DNS',
    TAB_DEBAUCHE_IMPORT: 'Débauche Excel',
    TAB_TEMPLATE: 'Télécharger le modèle DNS',
    SEARCH_PLACEHOLDER: 'Matricule, nom ou prénom…',
    TYPE_ALL: 'Tous les types',
    COMPANY_ALL: 'Toutes les sociétés',
    BTN_CREATE: 'Nouvel adhérent'
  },

  PRICING: {
    BADGE: 'Personnel d\'administration',
    PAGE_TITLE: 'Tarification des actes',
    PAGE_SUBTITLE:
      'Activez le tarif, saisissez le montant en Ariary, puis enregistrez.',
    SEARCH_PLACEHOLDER: 'Libellé…',
    EMPTY: 'Aucun acte dans cette catégorie.',
    EMPTY_FILTERED: 'Aucun acte ne correspond à votre recherche ou aux filtres sélectionnés.',
    CLEAR_FILTERS: 'Réinitialiser les filtres',
    LOAD_ERROR: 'Impossible de charger les tarifs',
    SAVE_OK: 'Tarif enregistré',
    SAVE_ERROR: 'Erreur lors de l\'enregistrement'
  },

  INVOICES: {
    BADGE: 'Personnel d\'administration',
    PAGE_TITLE: 'Facturation',
    PAGE_SUBTITLE:
      'Deux factures distinctes à la clôture du passage : soins et traitement, et prises en charge. Date = date du flux.',
    TAB_CARE: 'Soins et traitement',
    TAB_CARE_HINT: 'Consultation, infirmerie, médicaments',
    TAB_COVERAGE: 'Prises en charge',
    TAB_COVERAGE_HINT: 'Examens, orientations, lunettes',
    COL_KIND: 'Type',
    EMPTY_COVERAGE:
      'Aucune facture de prise en charge — elles apparaissent quand le médecin prescrit examens ou orientations, après clôture du passage.',
    SEARCH_PLACEHOLDER: 'N° facture, patient, matricule, société, affiliation…',
    FILTER_AFFILIATION: 'Affiliation',
    FILTER_AFFILIATION_ALL: 'Toutes les affiliations',
    FILTER_COMPANY: 'Société',
    FILTER_COMPANY_ALL: 'Toutes les sociétés',
    FILTER_SITE: 'Site',
    FILTER_SITE_ALL: 'Tous les sites',
    FILTER_SERVICE: 'Filière',
    FILTER_SERVICE_ALL: 'Toutes les filières',
    FILTER_DATE_FROM: 'Du',
    FILTER_DATE_TO: 'Au',
    CLEAR_FILTERS: 'Réinitialiser les filtres',
    RESULT_COUNT: (n) => `${n} facture${n === 1 ? '' : 's'}`,
    EMPTY: 'Aucune facture — elles apparaissent à la clôture complète du passage.',
    EMPTY_TITLE: 'Aucune facture pour l’instant',
    EMPTY_FILTERED: 'Aucune facture ne correspond aux filtres.',
    EMPTY_FILTERED_TITLE: 'Aucun résultat',
    EMPTY_COVERAGE_TITLE: 'Aucune prise en charge',
    LOADING: 'Chargement des factures…',
    OPEN_HINT: 'Voir le détail',
    LOAD_ERROR: 'Impossible de charger les factures',
    DETAIL_TITLE: 'Détail de la facture',
    BTN_CLOSE_DETAIL: 'Fermer',
    BTN_EXPORT: 'Exporter',
    BTN_EXPORT_EXCEL: 'Excel (.xlsx)',
    BTN_EXPORT_PDF: 'PDF',
    EXPORT_EMPTY: 'Aucune facture à exporter',
    EXPORT_OK: 'Export téléchargé',
    EXPORT_ERROR: 'Impossible d\'exporter les factures',
    COL_NUMBER: 'N° facture',
    COL_DATE: 'Date',
    COL_FULLNAME: 'Nom et prénom',
    COL_MATRICULE: 'Matricule',
    COL_COMPANY: 'Société',
    COL_DESCRIPTION: 'Désignation',
    COL_AMOUNT: 'Montant',
    COL_SERVICE: 'Filière',
    SECTION_CARE: 'SOINS ET TRAITEMENT',
    SECTION_COVERAGE: 'PRISES EN CHARGE',
    ITEM_CONSULTATION: 'Consultation',
    ITEM_NURSING: 'Soin infirmier',
    ITEM_MEDICATION: 'Médicament',
    STAT_COUNT: 'Factures',
    STAT_AMOUNT: 'Montant total',
    FILTER_PERIOD: 'Période',
    UNPRICED: 'Non tarifé',
    LABEL_SERVICE_DATE: 'Passage du',
    PAGINATION_LABEL: (from, to, total) => `Affichage ${from}–${to} sur ${total}`
  },

  PLACEHOLDER_BACK: 'Retour au tableau de bord',

  PLACEHOLDER: {
    PROFILE_TITLE: 'Mon profil',
    PROFILE_DESC:
      'La gestion avancée du profil administrateur sera disponible prochainement.',
    SETTINGS_TITLE: 'Paramètres',
    SETTINGS_DESC:
      'Le module de paramétrage du personnel d\'administration est en cours de finalisation.',
    REPORTS_TITLE: 'Rapports',
    REPORTS_DESC:
      'Les rapports détaillés seront disponibles ici, avec export et filtres avancés.',
  },

  NOTIFICATIONS: {
    PAGE_TITLE: 'Centre de notifications',
    PAGE_SUBTITLE:
      'Alertes liées aux sociétés, adhérents et actions sur votre espace personnel d\'administration.',
    BTN_REFRESH: 'Actualiser',
    BTN_MARK_ALL: 'Tout marquer comme lu',
    BTN_MARK_ONE: 'Marquer comme lu',
    BTN_DELETE: 'Supprimer',
    BTN_DELETE_READ: 'Supprimer les lues',
    CONFIRM_DELETE: 'Supprimer cette notification ?',
    CONFIRM_DELETE_READ: 'Supprimer toutes les notifications déjà lues ?',
    DELETE_SUCCESS: 'Notification supprimée',
    DELETE_READ_SUCCESS: (n) =>
      n === 0 ? 'Aucune notification lue à supprimer' : `${n} notification(s) lue(s) supprimée(s)`,
    STAT_TOTAL: 'Total',
    STAT_UNREAD: 'Non lues',
    LOADING: 'Chargement des notifications…',
    EMPTY_TITLE: 'Aucune notification',
    EMPTY_SUB: 'Les alertes apparaîtront ici lors des créations ou modifications.',
    EMPTY_UNREAD_TITLE: 'Aucune notification non lue',
    EMPTY_UNREAD_SUB: 'Vous êtes à jour.',
    PAGINATION_LABEL: (from, to, total) => `Affichage ${from}–${to} sur ${total}`
  },

  ACTIVITIES: {
    PAGE_TITLE: 'Activités récentes',
    PAGE_SUBTITLE:
      'Historique des créations, modifications et imports sur les sociétés et adhérents.',
    BTN_REFRESH: 'Actualiser',
    STAT_TOTAL: 'Total',
    STAT_CREATES: 'Créations',
    STAT_UPDATES: 'Modifications',
    STAT_DELETES: 'Suppressions',
    STAT_IMPORTS: 'Imports',
    LEGACY_HINT:
      'Journal d’audit en cours de remplissage — affichage provisoire des dernières créations.',
    LOADING: 'Chargement des activités…',
    EMPTY_TITLE: 'Aucune activité',
    EMPTY_SUB: 'Les mouvements apparaîtront ici lors des actions sur sociétés et adhérents.',
    GO_COMPANIES: 'Voir les sociétés',
    GO_MEMBERS: 'Voir les adhérents',
    PAGINATION_LABEL: (from, to, total) => `Affichage ${from}–${to} sur ${total}`
  },

  ACTIVITY_FEED_TITLE: 'Activité récente',
  ACTIVITY_EMPTY: 'Aucune activité à afficher',

  NOTIFICATIONS_TITLE: 'Notifications',
  NOTIFY_EMPTY: 'Aucune notification',
  NOTIFY_EMPTY_SUB: 'Vous êtes à jour',

  BTN_VIEW_ALL: 'Voir tout',

  ARIA_TOGGLE_MENU: 'Ouvrir le menu de navigation',
  ARIA_CLOSE_MENU: 'Fermer le menu de navigation',
  ARIA_TOGGLE_SIDEBAR: 'Réduire le menu latéral',
  ARIA_EXPAND_SIDEBAR: 'Développer le menu latéral',
  ARIA_USER_MENU: 'Menu du compte utilisateur',
  MOBILE_NAV_TITLE: 'Navigation',
  SIDEBAR_COLLAPSE: 'Réduire',
  SIDEBAR_EXPAND: 'Développer'
};
